'use strict';

import {debounceStickValue} from '../utils';

export default {
    update(val) {
        this.validator = val;
    },
    bind() {
        let dropping = false;
        let dropMark;

        const acceptDrop = (dt) => {
            if (this.validator) {
                return this.validator(dt);
            }

            return true;
        };

        const calcDropZonePosition = () => {
            const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

            const v = {
                x1: 0,
                y1: 0,
                x2: vw,
                y2: vh
            };

            const r = this.el.getBoundingClientRect();

            const z = {
                x1: r.left,
                y1: r.top,
                x2: r.left + r.width,
                y2: r.top + r.height
            };

            const x1 = Math.max(v.x1, z.x1);
            const y1 = Math.max(v.y1, z.y1);
            const x2 = Math.min(v.x2, z.x2);
            const y2 = Math.min(v.y2, z.y2);

            return {
                left: x1,
                top: y1,
                width: x2 - x1,
                height: y2 - y1
            };
        };

        function drawDropMark() {
            const el = document.createElement('DIV');
            const txt = document.createElement('DIV');

            el.classList.add('drop-mark');
            txt.classList.add('drop-mark-text');
            txt.textContent = 'Déposez les fichiers ici';

            const pos = calcDropZonePosition();
            el.style.left = `${pos.left}px`;
            el.style.top = `${pos.top}px`;
            el.style.width = `${pos.width}px`;
            el.style.height = `${pos.height}px`;

            el.appendChild(txt);
            return el;
        }

        const setDropping = debounceStickValue((d) => {
            dropping = d;

            if (dropping) {
                this.el.classList.add('dropping');
                dropMark = drawDropMark();
                this.el.appendChild(dropMark);
            } else {
                this.el.classList.remove('dropping');
                if (dropMark) {
                    this.el.removeChild(dropMark);
                    dropMark = undefined;
                }
            }
        }, true, 100);

        this.enterDrop = function enterDrop(e) {
            e.preventDefault();

            if (acceptDrop(e.dataTransfer)) {
                setDropping(true);
            }
        };

        this.exitDrop = function exitDrop(e) {
            e.preventDefault();
            setDropping(false);
        };

        this.gotDrop = (e) => {
            e.preventDefault();
            setDropping(false);

            if (acceptDrop(e.dataTransfer)) {
                Array.from(e.dataTransfer.files || []).forEach((f) => {
                    this.vm.$emit('file-drop', f);
                });
            }
        };

        this.el.addEventListener('drop', this.gotDrop);
        this.el.addEventListener('dragdrop', this.gotDrop);
        this.el.addEventListener('dragenter', this.enterDrop);
        this.el.addEventListener('dragover', this.enterDrop);
        this.el.addEventListener('dragleave', this.exitDrop);
    },
    unbind() {
        this.el.removeEventListener('drop', this.gotDrop);
        this.el.removeEventListener('dragdrop', this.gotDrop);
        this.el.removeEventListener('dragenter', this.enterDrop);
        this.el.removeEventListener('dragover', this.enterDrop);
        this.el.removeEventListener('dragleave', this.exitDrop);
    }
};



// WEBPACK FOOTER //
// ./src/directives/drop-zone.js